import { render, staticRenderFns } from "./StudentsWalletTransactionReceiptReportFilter.vue?vue&type=template&id=16c5d844&"
import script from "./StudentsWalletTransactionReceiptReportFilter.vue?vue&type=script&lang=js&"
export * from "./StudentsWalletTransactionReceiptReportFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports